<template>
  <section id="queueNotification-page">
    <h1>{{userFirstName}}, por favor dirija-se ao:</h1>
    <div class="serviceDesk__number">
      <span>Guichê {{serviceDeskNumber}}</span>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'QueueNotification',
  async created() {
    setTimeout(async() => await this.goNextStep('checkin_step'), 4 * 60 * 1000);
  },
  computed: {
    ...mapGetters(['global/userFirstName']),
    ...mapState({
      serviceDeskNumber: ({ queue }) => queue.data.serviceDesk.number,
    }),
  },
};
</script>
<style lang="scss">
#queueNotification-page {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 18vh;

  h1 {
    color: var(--color-grey-0);
    margin: 20px;
  }

  .serviceDesk__number {
    width: 300px;
    height: 100px;
    border-radius: 90px;
    background-color: var(--color-grey-0);
    border: 5px solid var(--color-primary-lighten-2);
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-size: 32px;
      color: var(--color-primary);
      font-weight: 500;
    }
  }
}

.queue-notification {
  background-color: var(--color-primary);
  border: 6px var(--color-grey-0) solid;
  animation: blinker 0.8s cubic-bezier(.5, 0, 1, 1) infinite alternate;

  @keyframes blinker { to { border-color: transparent } }

    header {
      border-bottom: 1px solid rgba(255,255,255,0.2);
      .header__title {
        color: var(--color-grey-0);
      }
    }

  .container {
    padding: 0;
  }
}
</style>
